import { render, staticRenderFns } from "./DocumentoValidado.vue?vue&type=template&id=4f55b0e1&scoped=true&"
import script from "./DocumentoValidado.vue?vue&type=script&lang=js&"
export * from "./DocumentoValidado.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoValidado.vue?vue&type=style&index=0&id=4f55b0e1&prod&scoped=true&lang=stylus&"
import style1 from "./DocumentoValidado.vue?vue&type=style&index=1&id=4f55b0e1&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55b0e1",
  null
  
)

export default component.exports